import moment from 'moment';
import Request from './../../request';
import { IDepositResourceShortProps } from '../../../props/finance/incomes/deposits';

// import props

const DepositService = {
    retrieve: async (qs?: string): Promise<IDepositResourceShortProps[]> => {
        try {
            const result = await Request.get(`/api/deposits?${qs}`);
            return result;
        } catch (e) {
            throw (e);
        }
    },
    read: async (type: 'vendor' | 'user', id: string): Promise<IDepositResourceShortProps> => {
        try {
            const result = await Request.get(`/api/deposits/${type}s/${id}`);
            return result;
        } catch (e) {
            throw (e);
        }
    }
}

export default DepositService;